import { InjectionToken, Provider } from '@angular/core';
import { ShellEvents } from '../models/shell-event';

/**
 * Injection token for shell events shared with every mounted remote integration.
 * Shared events are merged with the events configured on each `RemoteIntegrationConfig`.
 */
export const RemoteIntegrationSharedEvents = new InjectionToken<ShellEvents>('RemoteIntegrationSharedEvents', {
  providedIn: 'root',
  factory: (): ShellEvents => ({}),
});

/** Provides shared shell events for all remote integrations using a factory function. */
export const provideRemoteIntegrationSharedEvents = (factory: () => ShellEvents): Provider => ({
  provide: RemoteIntegrationSharedEvents,
  useFactory: factory,
});
